import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { GlobalServicesService } from '../services/global-services.service';
import { environment } from 'src/environments/environment';
import { BreadcrumbService   } from 'xng-breadcrumb';
import { FileUploadService } from '../services/file-upload.service';

@Component({
    selector: 'app-side-nav',
    templateUrl: './side-nav.component.html',
    styleUrls: ['./side-nav.component.css'],
    standalone: false
})
export class SideNavComponent implements OnInit {

  sourceImg = '';
  dashboardEnabled: boolean = true;
  copilotEnabled: boolean = true;
  jobsActive: boolean = true;
  usersActive: boolean = false;
  sideNavOptions: any = [];
  activePage: string = '';
  companyLogo: string = '';
  userPrivileges: Set<string> = new Set();

  constructor(private _router: Router, private globalservice: GlobalServicesService, private breadcrumbService: BreadcrumbService  , private fileUploadService: FileUploadService) {}

  ngOnInit() {
      this.globalservice.privilegeDetailsSubject.subscribe((privileges) => {
      this.userPrivileges = privileges;
      this.buildSideNav();
    });
    this.globalservice.companyMetadataSubject.subscribe((companyMetadata) => {
      if (companyMetadata) {
        this.dashboardEnabled = companyMetadata.company_config?.dashboard ?? false;
        this.copilotEnabled = companyMetadata.company_config?.copilot ?? false;
        this.buildSideNav();
      }
    });
    const companyDetails = localStorage.getItem('company-details');
    this.companyLogo = companyDetails ? JSON.parse(companyDetails).company_metadata.logo : '';
    if (this.companyLogo.length) this.sourceImg = this.companyLogo;
  }

  buildSideNav() {
    const copilotPrivileges = ['job_role.view', 'job_role.create', 'event.view', 'event.create'];
    this.sideNavOptions = [
      { name: 'Dashboard', icon: 'dashboard', isActive: false, url: '/dashboard', view: this.dashboardEnabled },
      { name: 'Agent Smith', icon: 'flash', isActive: false, url: 'copilot', view: this.copilotEnabled && this.hasAnyPrivilege(copilotPrivileges) },
      { name: 'Events', icon: 'events', isActive: false, url: 'events', view: this.hasPrivilege('event.create') || this.hasPrivilege('event.view') },
      { name: 'Candidates', icon: 'talent-pool', isActive: false, url: 'candidates', view: this.hasPrivilege('candidate.invite') || this.hasPrivilege('candidate.view') || this.hasPrivilege('candidate.bulk_action') },
      { name: 'Job Roles', icon: 'roles', isActive: false, url: 'roles', view: this.hasPrivilege('job_role.create') || this.hasPrivilege('job_role.view') },
      { name: 'Reports', icon: 'reports', isActive: false, url: 'reports', view: this.hasPrivilege('report.view') },
      // { name: 'Email Template', icon: 'email-template', isActive: false, url: 'email-template', view: this.hasPrivilege('email_template.create') || this.hasPrivilege('email_template.view') },
      // { name: 'Form Builder', icon: 'forms', isActive: false, url: 'forms', view: true },
      { name: 'Settings', icon: 'settings', isActive: false, url: 'settings', view: true },
      { name: 'Manage Content', icon: 'sso-redirect', isActive: false, url: 'sso', view: this.hasPrivilege('iamneo_platform.access') }
    ];
  }

  hasPrivilege(key: string): boolean {
    return this.userPrivileges.has(key);
  }
  hasAnyPrivilege(privileges: string[]): boolean {
    return privileges.some(privilege => this.userPrivileges.has(privilege));
  }
  updateBreadcrumb(title: string): void {
    this.breadcrumbService.set('@dynamic', title);
  }  

  iconClick = (option: any) => {
    this.sideNavOptions.forEach((item: any) => {
      if (item.url === option.url) {
        item.isActive = true;
      } else {
        item.isActive = false;
      }
    });
    if (option.url === 'sso') {
      this.openSSO();
    } else {
      this._router.navigateByUrl(option.url);
    }
  }

  openSSO = () => {
    let payload = {
      source: "neo-hire",
    };
    this.globalservice.ssoLoginFastApi(payload).subscribe((resp: any) => {
      let url = resp.body.url;
      if (resp.body.url) {
        window.open(url, '_blank');
      }
    })
  }
}
